import request from '@/utils/request'

// 中性配置新增
export function nentralConf(data) {
  return request({
    url: '/nentralConf',
    method: 'post',
    data: data
  })
}

// 中性配置修改
export function nentralConfUpdate(data) {
  return request({
    url: '/nentralConf',
    method: 'put',
    data: data
  })
}

// 根据域名获取中性配置
export function nentralConfByDomain(data) {
  return request({
    url: '/nentralConf/confByDomain',
    method: 'get',
    params: data
  })
}

// 中性配置获取
export function nentralConfInfo(query) {
  return request({
    url: '/nentralConf/info',
    method: 'get',
    params: query
  })
}
